import type { ActionPanelVariant } from './types'

/**
 * What the panel renders, as a pure function of the viewport and the buyer's
 * stored preference:
 *
 *                isExpanded=true    isExpanded=false
 *      desktop    wide               narrow
 *      mobile     narrow             minimized
 *
 * A viewport change moves this; it never moves `isExpanded`. So crossing the
 * breakpoint changes what renders, not what is stored, and coming back restores
 * what the buyer chose.
 */
export const getActionPanelVariant = ({
  isExpanded,
  isMobile,
}: {
  isExpanded: boolean
  isMobile: boolean
}): ActionPanelVariant => {
  if (!isMobile) return isExpanded ? 'wide' : 'narrow'

  return isExpanded ? 'narrow' : 'minimized'
}
